export default "__VITE_ASSET__QJETYtE2__"